import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import PageNotFound from '@/views/PageNotFound'
import cylinderRoutes from '@/router/routes/cylinderRoutes'
import etalonRoutes from '@/router/routes/etalonRoutes'
import dropRoutes from '@/router/routes/dropRoutes'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
    meta: { layout: 'base-layout' }
  },
  {
    path: '/dashboard/profile',
    meta: { layout: 'dashboard-layout' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Admin/ProfilePage.vue')
  },
  {
    path: '/dashboard/catalog',
    name: 'catalog-page',
    meta: { layout: 'dashboard-layout' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/CatalogView.vue')
  },
  {
    path: '/dashboard/catalog/:id',
    name: 'catalog-item-page',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/CatalogView.vue')
  },
  {
    path: '/dashboard/catalog/:id/products',
    name: 'catalog-products-page',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Products/ProductsView')
  },
  {
    path: '/dashboard/products',
    name: 'products',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Products/ProductsView.vue')
  },
  {
    path: '/dashboard/products/:id',
    name: 'products-item',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/ProductView.vue')
  },
  {
    path: '/dashboard/clients',
    name: 'client-list',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Clients/ClientListView')
  },
  {
    path: '/dashboard/clients/create',
    name: 'client-create',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Clients/ClientCreateView')
  },
  {
    path: '/dashboard/clients/:id/update',
    name: 'client-update',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Clients/ClientUpdateView')
  },
  // Etalon Orders
  {
    path: '/dashboard/orders/etalon/:section',
    name: 'etalon-order-list',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Orders/v2/EtalonOrderListView.vue')
  },
  {
    path: '/dashboard/orders/:id',
    name: 'etalon-order-view',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Orders/v2/EtalonOrderView.vue')
  },
  ...etalonRoutes,
  ...cylinderRoutes,
  ...dropRoutes,
  // DROP Clients
  {
    path: '/dashboard/drop-users',
    name: 'drop-users-list',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/DropClients/DropClientListView.vue')
  },
  {
    path: '/dashboard/drop-user/:id',
    name: 'drop-user',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/DropClients/DropClientView.vue'),
    children: [
      {
        path: 'general',
        component: () => import('../views/DropClients/ClientPageComponents/ClientGeneral.vue'),
        meta: { layout: 'dashboard-layout' }
      },
      {
        path: 'balance',
        component: () => import('../views/DropClients/ClientPageComponents/ClientBalance.vue'),
        meta: { layout: 'dashboard-layout' }
      },
      {
        path: 'withdraw',
        component: () => import('../views/DropClients/ClientPageComponents/ClientWithdraws.vue'),
        meta: { layout: 'dashboard-layout' }
      },
      {
        path: 'exports',
        component: () => import('../views/DropClients/ClientPageComponents/ClientExports.vue'),
        meta: { layout: 'dashboard-layout' }
      },
      {
        path: 'logs',
        component: () => import('../views/DropClients/ClientPageComponents/ClientLogs.vue'),
        meta: { layout: 'dashboard-layout' }
      }
    ]
  },
  // DROP Withdraws
  {
    path: '/dashboard/drop-withdraws',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/DropWithdraws/WithdrawListView.vue')
  },
  {
    path: '/dashboard/drop-messages',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/DropMessages/DropMessageListPage.vue')
  },
  {
    path: '/dashboard/drop-payment-documents',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/DropPaymentDocuments/DropPaymentDocumentsView.vue')
  },
  // ADMIN
  {
    path: '/dashboard/admin/catalog',
    name: 'admin-categories',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/CatalogSettingView')
  },
  {
    path: '/dashboard/admin/content',
    name: 'admin-categories',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/ContentsView')
  },
  {
    path: '/dashboard/admin/article/create',
    name: 'admin-categories',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/CreateContentView')
  },
  {
    path: '/dashboard/admin/article/:id',
    name: 'admin-categories',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/EditContentView')
  },
  {
    path: '/dashboard/admin/nova-poshta-senders/:store_name',
    name: 'admin-nova-poshta-senders',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/NovaPoshtaSenders/SenderListView')
  },
  {
    path: '/dashboard/admin/rozetka-stores',
    name: 'admin-rozetka-stores',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/RozetkaStores/RozetkaStoreListView.vue')
  },
  {
    path: '/dashboard/admin/payment-contragents/:type',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/PaymentContragent/PaymentContragentListView.vue')
  },
  {
    path: '/dashboard/admin/cylinder/payment-contragents',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/CylinderPaymentContragent/CylinderPaymentContragentListView.vue')
  },
  {
    path: '/dashboard/admin/roles',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Roles/RoleListPage.vue')
  },
  {
    path: '/dashboard/admin/roles/create',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Roles/CreateRolePage.vue')
  },
  {
    path: '/dashboard/admin/roles/:id',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Roles/EditRolePage.vue')
  },
  {
    path: '/dashboard/admin/workers/',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Users/WorkersListPage.vue')
  },
  {
    path: '/dashboard/admin/workers/create',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Users/CreateWorkerPage.vue')
  },
  {
    path: '/dashboard/admin/workers/:id',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Users/EditWorkerPage.vue')
  },
  // STATISTICS
  {
    path: '/dashboard/statistics/products',
    name: 'admin-product-statistics',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Statistics/ProductStatistics')
  },
  {
    path: '/dashboard/statistics/orders',
    name: 'admin-order-statistics',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Statistics/OrderStatistics')
  },
  {
    path: '/dashboard/admin/notification-create',
    name: 'create-notification',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Notifications/CreateNotificationView')
  },
  {
    path: '/dashboard/admin/catalog-dropship-b2b',
    name: 'admin-categories-drop',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/DropCatalogSettingView')
  },
  {
    path: '/dashboard/admin/drop-settings',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Drop/DropSettings.vue')
  },
  {
    path: '/dashboard/admin/cylinder-settings',
    name: 'admin-cylinder-settings',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Cylinder/CylinderSettings.vue')
  },
  {
    path: '/dashboard/admin/cylinder-pages',
    name: 'admin-cylinder-pages',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Cylinder/CylinderPagesList.vue')
  },
  {
    path: '/dashboard/admin/cylinder-pages/create',
    name: 'admin-cylinder-pages-create',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Cylinder/CylinderPageCreate.vue')
  },
  {
    path: '/dashboard/admin/cylinder-pages/:id',
    name: 'admin-cylinder-pages-edit',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Cylinder/CylinderPageEdit.vue')
  },
  {
    path: '/dashboard/admin/cylinder-blogs',
    name: 'admin-cylinder-blogs',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Cylinder/CylinderBlogList.vue')
  },
  {
    path: '/dashboard/admin/cylinder-blogs/create',
    name: 'admin-cylinder-blogs-create',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Cylinder/CylinderBlogCreate.vue')
  },
  {
    path: '/dashboard/admin/cylinder-blogs/:id',
    name: 'admin-cylinder-blogs-edit',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/Cylinder/CylinderBlogEdit.vue')
  },
  {
    path: '/dashboard/logs',
    name: 'admin-categories-log',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Logs/LogEventListPage.vue')
  },
  {
    path: '/dashboard/rozetka-logs',
    name: 'admin-rozetka-log',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Logs/RozetkaLogsPage.vue')
  },
  {
    path: '/dashboard/system-messages',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../views/Admin/System/SystemMessageList.vue')
  },
  {
    path: '*',
    meta: { layout: 'base-layout' },
    component: PageNotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
